import React from "react";
import LegalPage from "./LegalPage";

const Privacy = () => <LegalPage tKey="pages.privacy" testId="privacy-page" />;
export default Privacy;
